import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { UserContext, UserContextType } from '../contexts/userContext'
import { routes } from '../routes'
import { useTheme } from '../contexts/ThemeContext'
import { Spinner } from '../common/components/loaders/spinner/Spinner'

import styles from './Protected.module.css'

export const Protected: React.FC<React.PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()
  const { user, loginState } = useContext(UserContext) as UserContextType
  const { logoUrl } = useTheme()
  const { t } = useTranslation()
  const [waitCounter, setWaitCounter] = useState(0)

  useEffect(() => {
    if (user == null) {
      if (loginState === 'PENDING') {
        if (waitCounter > 6) {
          navigate(routes.login)
        } else {
          setTimeout(() => {
            setWaitCounter(waitCounter + 1)
          }, 500)
        }
      } else if (loginState === 'LOGGED_OUT') {
        navigate(routes.login)
      }
    } else if (!user.termsAccepted) {
      navigate(routes.onboardingWizard)
    }
  }, [loginState, navigate, user, waitCounter])

  if (loginState === 'LOGGED_OUT' || loginState === 'PENDING') {
    return (
      <div className={styles.container}>
        <img src={logoUrl} alt='Logo' width={200} />
        <h2>{t('splash.session_status', 'Checking session status, please wait')}</h2>
        <Spinner remSize={4} />
      </div>
    )
  }

  return <>{children}</>
}
